import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Row } from 'antd';
import { withTranslation } from 'react-i18next';
import cn from 'classnames';
import _ from 'lodash';

import TabsMenu from '../../common/UI/TabsMenu';
import ButtonClose from '../../common/UI/ButtonClose';
import LoadingSpin from '../../common/LoadingSpin';
import getLink from '../../common/router/getLink';
import SCENE_TYPES from '../../../configs/sceneTypes';
import SCENE_CONTAINER from '../../../configs/sceneContainer';
import ProcessNotify from '../../common/UI/ProcessNotify';
import ButtonTransparent from '../../common/UI/ButtonTransparent';
import Icon from '../../common/UI/Icon';

import routes from '../../../routes';
import sceneActions from '../../../actions/sceneActions';

import styles from './header.less';

class Header extends Component {
  static propTypes = {
    tabs: ImmutablePropTypes.list,
    headerText: PropTypes.string,
    record: ImmutablePropTypes.map.isRequired,
    catalog: ImmutablePropTypes.map.isRequired,
    scene: ImmutablePropTypes.map.isRequired,
    getExtParams: PropTypes.func.isRequired,
    hasBeenEdit: PropTypes.bool.isRequired,
    withTabsMenu: PropTypes.bool,
    isWebForm: PropTypes.bool,
    onClose: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      prevRecordId: null,
      nextRecordId: null,
    };
  }

  componentDidMount() {
    this.getNavigateRecords();
  }

  componentDidUpdate(prevProps, prevState) {
    const recordId = this.props.record && this.props.record.get('id');
    const prevRecordId = prevProps.record && prevProps.record.get('id');
    if (recordId != prevRecordId) {
      this.getNavigateRecords();
    }
  }

  getNavigateRecords = () => {
    const recordId = this.props.record && this.props.record.get('id');
    const sceneId = this.props.scene && this.props.scene.get('sceneId');
    sceneActions.getNavigateRecords(sceneId, recordId, ({ prevRecordId, nextRecordId }) => {
      this.setState({ prevRecordId, nextRecordId });
    });
  };

  getRecordActivitiesComponent = () => {
    const { scene } = this.props;

    const sceneType = scene && scene.get('type');

    switch (sceneType) {
      case SCENE_TYPES.RECORD:
        return require('../RecordHeader/RecordActivities').default;

      case SCENE_TYPES.RECORDS_BATCH_UPDATE:
        return require('../../RecordsBatch/RecordsBatchUpdate/batchUpdateHeader/RecordsBatchUpdateActivities').default;

      case SCENE_TYPES.RECORDS_BATCH_DELETE:
        return require('../../RecordsBatch/RecordsBatchDelete/batchDeleteHeader/RecordsBatchDeleteActivities').default;

      default:
        return require('../RecordHeader/RecordActivities').default;
    }
  };

  _getExtParams = () => {
    const { getExtParams } = this.props;

    if (getExtParams) {
      return getExtParams();
    }
    const { record, catalog, tabId } = this.props;

    return {
      sectionId: catalog.get('sectionId'),
      catalogId: catalog.get('id'),
      recordId: record && (record.get('isNew') ? '$new' : record.get('id')),
      tabId,
    };
  };

  navigatePrevRecord = () => {
    this.openRecord(this.state.prevRecordId);
  };

  navigateNextRecord = () => {
    this.openRecord(this.state.nextRecordId);
  };

  openRecord = (recordId) => {
    if (!recordId) {
      return;
    }

    const link = getLink(this.props.location, routes.record, { recordId });
    this.props.history.push(link);
  };

  onRefresh = () => {
    const { tabId, onRefresh } = this.props;
    const SPECIAL_TABS = ['links', 'history', 'chat', 'manual'];
    const logicalTab = SPECIAL_TABS.includes(tabId) ? tabId : 'main';
    onRefresh && onRefresh(logicalTab);
  };

  isLoading = () => {
    const { record, tabId } = this.props;

    if (!record) {
      return;
    }

    const TABS_IDS = {
      MAIN: 'main',
      LINKS: 'links',
      CHAT: 'chat',
      HISTORY: 'history',
      MANUAL: 'manual',
    };

    if (tabId === TABS_IDS.MAIN) {
      return record.get('loading');
    }
    if (tabId === TABS_IDS.LINKS) {
      return record.get('linkedDataLoading');
    }
    if (tabId === TABS_IDS.HISTORY) {
      return record.getIn(['history', 'loading']);
    }
  };

  render() {
    const {
      tabs,
      record,
      catalog,
      scene,
      withTabsMenu,
      isWebForm,
      hasBeenEdit,
      headerText,
      onClose,
      FilterComponent,
      onClear,
      isDeleting,
      tabId,
      onTabChange,
      fields,
      openTab,
      t,
      baseTabs,
      isNew,
      batchDelete,
      onRefresh,
      ...props
    } = this.props;

    const sceneId = scene && scene.get('sceneId');
    const isBatchRecords =
      scene &&
      (scene.get('type') === SCENE_TYPES.RECORDS_BATCH_UPDATE ||
        scene.get('type') === SCENE_TYPES.RECORDS_BATCH_DELETE);
    const Activities = this.getRecordActivitiesComponent();
    const extParams = this._getExtParams();
    const isPopup = scene && scene.get('container') === SCENE_CONTAINER.POPUP;
    const isLoading = this.isLoading();
    let updateProcess;

    const changedFields =
      record && record.getIn(['updateProcesses', 'fields']) && record.getIn(['updateProcesses', 'fields']).toJS();

    if (!_.isEmpty(changedFields)) {
      updateProcess = changedFields && Object.values(changedFields).some((f) => f.inProcess);
    }

    let recordId = null;
    if (record) {
      recordId = record.get('isNew') ? null : record.get('id');
    }

    const { prevRecordId, nextRecordId } = this.state;
    const showNavigate = prevRecordId || nextRecordId;

    return (
      <div className={styles.container}>
        <Row type="flex" justify="space-between" align="middle" className={styles.containerHeader}>
          <Row type="flex" align="middle">
            {FilterComponent}

            {showNavigate ? (
              <div className={styles.headerNavigate}>
                <ButtonTransparent
                  onClick={this.navigatePrevRecord}
                  className={styles.headerNavigatePrev}
                  disabled={!prevRecordId}
                  title={t('record.navigate.prev')}
                >
                  <Icon type="icon arrows-chevron-medium-big-3-01" />
                </ButtonTransparent>
                <ButtonTransparent
                  onClick={this.navigateNextRecord}
                  className={styles.headerNavigateNext}
                  disabled={!nextRecordId}
                  title={t('record.navigate.next')}
                >
                  <Icon type="icon arrows-chevron-medium-big-4-01" />
                </ButtonTransparent>
              </div>
            ) : null}

            <h2 className={styles.headerText} title={headerText}>
              {recordId && <small className={styles.headerId}>{recordId}</small>}
              {headerText}
            </h2>
          </Row>

          <Row type="flex" align="middle" className={styles.headerActivitiesWrapper}>
            {isLoading && isBatchRecords && <LoadingSpin className={styles.loadingSpinHeaderText} />}
            <Activities
              record={record}
              catalog={catalog}
              sceneId={sceneId}
              hasBeenEdit={hasBeenEdit}
              withTabsMenu={withTabsMenu}
              isWebForm={isWebForm}
              onClear={onClear}
              onClose={onClose}
              onRefresh={this.onRefresh}
              {...props}
            />
            {(!isWebForm || isPopup) && (
              <ButtonClose
                className={cn({
                  [styles.buttonCloseDisabled]: isDeleting,
                })}
                onClick={onClose}
                shiftRight
              />
            )}
          </Row>
        </Row>

        {!batchDelete && (
          <div className={styles.tabsContainer}>
            <div className={styles.recordTabs}>
              <TabsMenu items={tabs} activeId={tabId} extParams={extParams} />
            </div>
            {baseTabs && !isWebForm && (
              <div className={styles.baseTabs}>
                <TabsMenu items={baseTabs} activeId={tabId} extParams={extParams} />
              </div>
            )}
          </div>
        )}
        <ProcessNotify show={updateProcess} />
      </div>
    );
  }
}

export default withTranslation()(withRouter(Header));
